import { render, staticRenderFns } from "./ShueiJinJiouDetail.vue?vue&type=template&id=a9967f4c"
import script from "./ShueiJinJiouDetail.vue?vue&type=script&lang=js"
export * from "./ShueiJinJiouDetail.vue?vue&type=script&lang=js"
import style0 from "./ShueiJinJiouDetail.vue?vue&type=style&index=0&id=a9967f4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports